import {
  List, ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import { useContext } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import type { InstrumentType } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';

const useStyles = makeStyles()(() => ({
  container: {
    width: '240px',
    height: '226px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  containerStrings: {
    width: '240px',
    height: '210px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.23)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  list: {
    flexGrow: 1,
    overflowY: 'auto', // to make the list scrollable
  },
}));

export interface SpecificInstrumentProps {
  setCurrentStep: (step: number) => void;
}

const windInstruments = {
  alto_sax: 'home.input.dialog.specify_instrument.instruments.alto_sax',
  tenor_sax: 'home.input.dialog.specify_instrument.instruments.tenor_sax',
  soprano_sax: 'home.input.dialog.specify_instrument.instruments.soprano_sax',
  baritone_sax: 'home.input.dialog.specify_instrument.instruments.baritone_sax',
  clarinet: 'home.input.dialog.specify_instrument.instruments.clarinet',
  flute: 'home.input.dialog.specify_instrument.instruments.flute',
  recorder: 'home.input.dialog.specify_instrument.instruments.recorder',
  oboe: 'home.input.dialog.specify_instrument.instruments.oboe',
  bassoon: 'home.input.dialog.specify_instrument.instruments.bassoon',
  french_horn: 'home.input.dialog.specify_instrument.instruments.french_horn',
  trumpet: 'home.input.dialog.specify_instrument.instruments.trumpet',
  trombone: 'home.input.dialog.specify_instrument.instruments.trombone',
  tuba: 'home.input.dialog.specify_instrument.instruments.tuba',
};

const stringInstruments = {
  violin: 'home.input.dialog.specify_instrument.instruments.violin',
  viola: 'home.input.dialog.specify_instrument.instruments.viola',
  cello: 'home.input.dialog.specify_instrument.instruments.cello',
  double_bass: 'home.input.dialog.specify_instrument.instruments.double_bass',
};

const SpecificInstrument: React.FC<SpecificInstrumentProps> = ({ setCurrentStep }) => {
  const { classes } = useStyles();
  const { settings, setSettings } = useContext(TranscriptionDialogContext);
  const { t } = useTranslation();

  const isWind = Object.keys(windInstruments).includes(settings.instruments[0])
    || settings.instruments.includes('wind');
  const specificInstruments = isWind ? windInstruments : stringInstruments;
  const TYPE: InstrumentType = isWind ? 'wind' : 'strings';

  const handleClick = (type: InstrumentType) => {
    setSettings({ instruments: [type] });
    setCurrentStep(4);
  };

  return (
    <div className={TYPE === 'wind' ? classes.container : classes.containerStrings}>
      <List className={TYPE === 'wind' ? classes.list : undefined}>
        {Object.entries(specificInstruments).map(([key, value]) => {
          return (
            <ListItem key={key} disablePadding>
              <ListItemButton
                id={`btn_wizard_specify_${key}`}
                onClick={() => handleClick(key as InstrumentType)}
              >
                <ListItemText primary={t(value)} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default SpecificInstrument;
